import { Interface } from '@ethersproject/abi'
import { Signature } from '@ethersproject/bytes'
import { ERC20__factory, WyvernStatic__factory } from 'contracts/types'

import { EIP712Domain } from './types'

export const UNVEST_TRADER_FEE_COLLECTOR =
  process.env.NEXT_PUBLIC_UNVEST_FEE_COLLECTOR_ADDRESS || ''

export const EMPTY_WYVERN_CONTRACTS = {
  WyvernAtomicizer: '',
  WyvernStatic: '',
  WyvernRegistry: '',
  WyvernExchange: '',
}

export const WYVERN_CONTRACTS = {
  mainnet: {
    WyvernAtomicizer: '0x8E3af7C14c5EF71935A9c5FCfa13d431E21EB750',
    WyvernStatic: '0xCd962778bC57CeFc05A6AfB3190D03d3D2558f94',
    WyvernRegistry: '0xAfD759C7356053D6CCBE6d416D4F3b66C6eA6bE3',
    WyvernExchange: '0x9D190e411F7212462b52e176cE404A64df88e749',
  },
  ropsten: {
    WyvernAtomicizer: '0x8E3af7C14c5EF71935A9c5FCfa13d431E21EB750',
    WyvernStatic: '0xCd962778bC57CeFc05A6AfB3190D03d3D2558f94',
    WyvernRegistry: '0xAfD759C7356053D6CCBE6d416D4F3b66C6eA6bE3',
    WyvernExchange: '0x9D190e411F7212462b52e176cE404A64df88e749',
  },
  polygon: {
    WyvernAtomicizer: '0x8E3af7C14c5EF71935A9c5FCfa13d431E21EB750',
    WyvernStatic: '0xCd962778bC57CeFc05A6AfB3190D03d3D2558f94',
    WyvernRegistry: '0xAfD759C7356053D6CCBE6d416D4F3b66C6eA6bE3',
    WyvernExchange: '0x9D190e411F7212462b52e176cE404A64df88e749',
  },
  mumbai: {
    WyvernAtomicizer: '0x8E3af7C14c5EF71935A9c5FCfa13d431E21EB750',
    WyvernStatic: '0xCd962778bC57CeFc05A6AfB3190D03d3D2558f94',
    WyvernRegistry: '0xAfD759C7356053D6CCBE6d416D4F3b66C6eA6bE3',
    WyvernExchange: '0x9D190e411F7212462b52e176cE404A64df88e749',
  },
  bsc: {
    WyvernAtomicizer: '0x8E3af7C14c5EF71935A9c5FCfa13d431E21EB750',
    WyvernStatic: '0xCd962778bC57CeFc05A6AfB3190D03d3D2558f94',
    WyvernRegistry: '0xAfD759C7356053D6CCBE6d416D4F3b66C6eA6bE3',
    WyvernExchange: '0x9D190e411F7212462b52e176cE404A64df88e749',
  },
  avalanche: {
    WyvernAtomicizer: '0x8E3af7C14c5EF71935A9c5FCfa13d431E21EB750',
    WyvernStatic: '0xCd962778bC57CeFc05A6AfB3190D03d3D2558f94',
    WyvernRegistry: '0xAfD759C7356053D6CCBE6d416D4F3b66C6eA6bE3',
    WyvernExchange: '0x9D190e411F7212462b52e176cE404A64df88e749',
  },
}

export const getWyvernContracts = (chainId: number) => {
  if (chainId === 1) {
    return WYVERN_CONTRACTS.mainnet
  } else if (chainId === 3) {
    return WYVERN_CONTRACTS.ropsten
  } else if (chainId === 56) {
    return WYVERN_CONTRACTS.bsc
  } else if (chainId === 137) {
    return WYVERN_CONTRACTS.polygon
  } else if (chainId === 43114) {
    return WYVERN_CONTRACTS.avalanche
  } else if (chainId === 80001) {
    return WYVERN_CONTRACTS.mumbai
  }

  return EMPTY_WYVERN_CONTRACTS
}

export const getWyvernEIP712Domain = (chainId: number): EIP712Domain => {
  return {
    name: 'Unvest Protocol',
    version: '1.0',
    chainId,
    verifyingContract: getWyvernContracts(chainId).WyvernExchange,
  }
}

export const EIP712_DOMAIN = {
  name: 'EIP712Domain',
  fields: [
    { name: 'name', type: 'string' },
    { name: 'version', type: 'string' },
    { name: 'chainId', type: 'uint256' },
    { name: 'verifyingContract', type: 'address' },
  ],
}

export const EIP712_ORDER = {
  name: 'Order',
  fields: [
    { name: 'registry', type: 'address' },
    { name: 'maker', type: 'address' },
    { name: 'staticTarget', type: 'address' },
    { name: 'staticSelector', type: 'bytes4' },
    { name: 'staticExtradata', type: 'bytes' },
    { name: 'maximumFill', type: 'uint256' },
    { name: 'listingTime', type: 'uint256' },
    { name: 'expirationTime', type: 'uint256' },
    { name: 'salt', type: 'uint256' },
  ],
}

export const NEVER_EXPIRY = 100000000000000
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
export const ZERO_BYTES32 =
  '0x0000000000000000000000000000000000000000000000000000000000000000'
export const NULL_SIG = {
  v: 27,
  r: ZERO_BYTES32,
  s: ZERO_BYTES32,
} as Signature

export const atomicizerInterface = new Interface([
  {
    constant: false,
    inputs: [
      { name: 'addrs', type: 'address[]' },
      { name: 'values', type: 'uint256[]' },
      { name: 'calldataLengths', type: 'uint256[]' },
      { name: 'calldatas', type: 'bytes' },
    ],
    name: 'atomicize',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
])
export const staticInterface = WyvernStatic__factory.createInterface()
export const erc20Interface = ERC20__factory.createInterface()
